module.exports = __webpack_public_path__ + "img/b3886e5c440189df4884b06011c8abcd.png";